/* Por Siempre · tienda en Shopify.
   Prices, variants, stock and photos come from Shopify (JSON in sections/por-siempre.liquid);
   the copy and the card text live here and must match the printed card (01 Marca/Tarjeta de la caja). */
(function(){
  'use strict';

  var datosEl = document.getElementById('ps-datos');
  if(!datosEl) return;
  var D = JSON.parse(datosEl.textContent);
  var esFecha = function(s){ return typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s.trim()); };

  var TIENDA = {
    productos: {
      hija: {
        nombre: 'Collar «A mi hija»',
        titulo: 'Un collar para decirle a tu hija <em>lo que nunca le has dicho en voz alta.</em>',
        sub: 'Corazón dorado con circonita, caja regalo y una tarjeta escrita para ella. Lo abre, lo lee y se lo pone.',
        joyaTxt: 'Corazón dorado de acero inoxidable con una circonita en el centro.',
        cta: 'Lo quiero para mi hija',
        joya: 'El collar corazón',
        callada: 'Se queda callada un momento.',
        tarjeta: { para: 'A mi hija:', lineas: [
          'El día que naciste aprendí lo que es querer sin medida.',
          'Te he visto caerte y levantarte, y cada vez me has enseñado algo.',
          'Habrá días en los que no esté cerca. Ese día, este collar sí.',
          'Te quiero hoy, mañana y siempre.'
        ]},
        ficha: { titulo: 'Collar «A mi hija»', filas: [
          ['Pieza', 'Colgante corazón con cadena'],
          ['Material', 'Acero inoxidable'],
          ['Color', 'Dorado'],
          ['Piedra', 'Circonita'],
          D.largoCadena ? ['Largo de la cadena', D.largoCadena] : null,
          ['Incluye', 'Caja regalo y tarjeta'],
          ['Responsable en la UE', 'David del Real Gómez (Cachito de mí) · C/ Mancomunidad del Guadajoz, 12, 14850 Baena (Córdoba) · david@verusai.es'],
          ['Fabricante', D.fabricanteCollar || null]
        ]}
      },
      hijo: {
        nombre: 'Pulsera «A mi hijo»',
        titulo: 'Una pulsera para decirle a tu hijo <em>lo que nunca le has dicho en voz alta.</em>',
        sub: 'Pulsera de cuero trenzado, caja regalo y una tarjeta escrita para él. La abre, la lee y se la pone.',
        joyaTxt: 'Pulsera multicapa de cuero trenzado, en negro, con placa metálica.',
        cta: 'La quiero para mi hijo',
        joya: 'La pulsera de cuero',
        callada: 'Se queda callado un momento.',
        tarjeta: { para: 'A mi hijo:', lineas: [
          'Te vi dar tus primeros pasos y ahora te veo andar tu propio camino.',
          'No olvides nunca de dónde vienes ni lo mucho que vales.',
          'Si algún día te pesa el mundo, mira esta pulsera: aquí hay alguien que cree en ti.',
          'Te quiero hoy, mañana y siempre.'
        ]},
        ficha: { titulo: 'Pulsera «A mi hijo»', filas: [
          ['Pieza', 'Pulsera multicapa trenzada'],
          ['Material', 'Cuero, con placa metálica'],
          ['Color', 'Negro'],
          ['Largo', '21 cm'],
          ['Incluye', 'Caja regalo y tarjeta'],
          ['Responsable en la UE', 'David del Real Gómez (Cachito de mí) · C/ Mancomunidad del Guadajoz, 12, 14850 Baena (Córdoba) · david@verusai.es'],
          ['Fabricante', D.fabricantePulsera || null]
        ]}
      },
      dos: {
        nombre: '«A mis hijos» · 2 cajas',
        titulo: 'Para tus hijos: <em>lo que nunca les has dicho en voz alta.</em>',
        sub: 'El collar para ella y la pulsera para él, cada uno en su caja y con su tarjeta. Los abren, los leen y se los ponen.',
        joyaTxt: 'El corazón dorado para ella y la pulsera de cuero para él.',
        cta: 'Los quiero para mis hijos',
        joya: 'El collar y la pulsera',
        callada: 'Se quedan callados un momento.',
        pie: 'En el pack van 2 cajas, cada una con su tarjeta.'
      }
    },
    // Working days. Prepared 1 working day after the order, never before the stock is home.
    // Shipping: Correos Paq Ligero 48-72 h (margin up to 4).
    entrega: { preparacion: 1, min: 2, max: 4, stockEnCasa: esFecha(D.fechaStock) ? D.fechaStock.trim() : null },
    stock: { ver: D.mostrarStock === true, total: D.stockInicial > 0 ? D.stockInicial : 10 },
    // National holidays with no Correos delivery.
    festivos: ['2026-12-08','2026-12-25','2027-01-01','2027-01-06'],
    fechas: { navidad: '2026-12-23', reyes: '2027-01-05' }
  };

  // Shopify data: price in cents, variant id for the cart permalink, availability, stock and photos.
  Object.keys(TIENDA.productos).forEach(function(k){
    var p = TIENDA.productos[k], s = (D.productos && D.productos[k]) || {};
    p.precio = (s.precio || 0) / 100;
    p.pago = s.variante ? (D.carrito || '/cart') + '/' + s.variante + ':1' : null;
    p.disponible = s.disponible === true && !!p.pago;
    p.quedan = typeof s.quedan === 'number' ? s.quedan : null;
    p.fotos = Array.isArray(s.fotos) ? s.fotos : [];
  });

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function(id){ return document.getElementById(id); };
  var euros = function(n){ return n.toLocaleString('es-ES', {style:'currency', currency:'EUR'}); };

  // Sale price only inside the dates of Shopify's automatic discount (Spain time); the struck price is the normal one.
  var R = D.rebaja || {}, momento = Date.now();
  var enRebaja = R.pct > 0 && R.pct < 100 && esFecha(R.desde) && esFecha(R.hasta)
    && momento >= Date.parse(R.desde + 'T00:00:00+01:00') && momento <= Date.parse(R.hasta + 'T23:59:59+01:00');
  var rebajado = function(n){ return enRebaja ? Math.round(n * (100 - R.pct)) / 100 : n; };

  /* ---------- fechas en días laborables ---------- */
  function iso(d){ return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0'); }
  function laborable(d){ var w = d.getDay(); return w !== 0 && w !== 6 && TIENDA.festivos.indexOf(iso(d)) === -1; }
  function sumar(d, n){ var r = new Date(d); var c = 0; while(c < n){ r.setDate(r.getDate()+1); if(laborable(r)) c++; } return r; }
  function hoy(){ var d = new Date(); d.setHours(12,0,0,0); return d; }
  function texto(d, conDia){
    var t = d.toLocaleDateString('es-ES', conDia ? {weekday:'long', day:'numeric', month:'long'} : {day:'numeric', month:'long'});
    return t.replace(',', '');
  }
  function salida(desde){
    var e = TIENDA.entrega, sale = sumar(desde, e.preparacion);
    if(e.stockEnCasa){
      var trasStock = sumar(new Date(e.stockEnCasa + 'T12:00:00'), e.preparacion);
      if(trasStock > sale) sale = trasStock;
    }
    return sale;
  }
  function plazo(desde){
    var sale = salida(desde);
    return { sale: sale, min: sumar(sale, TIENDA.entrega.min), max: sumar(sale, TIENDA.entrega.max) };
  }
  // Last day to order so it arrives by "limite" at the latest.
  function ultimoDia(limiteIso){
    var lim = new Date(limiteIso+'T12:00:00');
    var d = new Date(lim);
    for(var i = 0; i < 40; i++){
      if(plazo(d).max <= lim) return d;
      d.setDate(d.getDate()-1);
    }
    return null;
  }

  function pintarFechas(){
    var h = hoy(), p = plazo(h);
    var rango = 'entre el ' + texto(p.min, true) + ' y el ' + texto(p.max, true);
    $('entregaTxt').innerHTML = 'Si lo pides hoy, <strong>llega ' + rango + '</strong>.';
    var enUnDia = iso(p.sale) === iso(sumar(h, 1));
    var prep = enUnDia ? 'Lo montamos y sale en 1 día laborable' : 'Lo montamos y sale de casa el ' + texto(p.sale, true);
    $('faqEntrega').textContent = prep + ', y la mensajería lo entrega en ' + TIENDA.entrega.min + ' a ' + TIENDA.entrega.max +
      ' días laborables. Si lo pides hoy, llega ' + rango + '.';
    $('rSale').textContent = texto(p.sale, true);
    $('rLlega').textContent = 'Entre el ' + texto(p.min) + ' y el ' + texto(p.max);

    var uN = ultimoDia(TIENDA.fechas.navidad), uR = ultimoDia(TIENDA.fechas.reyes);
    function limite(el, ultimo, para){
      var b = el.querySelector('b'), s = el.querySelector('span');
      if(ultimo && h <= ultimo){
        b.textContent = 'Pídelo antes del ' + texto(ultimo);
        s.textContent = 'Incluido ese día. Llega como tarde el ' + texto(new Date(TIENDA.fechas[para]+'T12:00:00')) + '.';
      } else {
        el.classList.add('fuera');
        b.textContent = 'Fuera de plazo';
        s.textContent = 'Ya no llega a tiempo para esta fecha.';
      }
    }
    limite($('limNavidad'), uN, 'navidad');
    limite($('limReyes'), uR, 'reyes');

    var aviso = 'Envío gratis · Caja regalo y tarjeta incluidas';
    if(uN && h <= uN) aviso = 'Pídelo antes del <strong>' + texto(uN) + '</strong> y llega antes de Nochebuena · Envío gratis';
    else if(uR && h <= uR) aviso = 'Pídelo antes del <strong>' + texto(uR) + '</strong> y llega antes de Reyes · Envío gratis';
    $('aviso').innerHTML = aviso;
  }

  /* ---------- stock real (de Shopify) ---------- */
  function pintarStock(p){
    var el = $('stock');
    if(!TIENDA.stock.ver || p.quedan == null){ el.hidden = true; return; }
    el.hidden = false;
    $('stockTxt').innerHTML = p.quedan > 0
      ? 'Quedan <strong>' + p.quedan + (p.quedan === 1 ? ' caja' : ' cajas') + '</strong> de la edición de Navidad.'
      : 'Las cajas de Navidad se han agotado. Estamos preparando más.';
    requestAnimationFrame(function(){ $('stockBar').style.setProperty('--s', Math.min(1, Math.max(.04, p.quedan / TIENDA.stock.total))); });
  }

  /* ---------- fichas ---------- */
  function ficha(f){
    var filas = f.filas.filter(Boolean).map(function(r){
      var v = r[1] == null ? '<span class="pend">por confirmar</span>' : r[1];
      return '<div><dt>' + r[0] + '</dt><dd>' + v + '</dd></div>';
    }).join('');
    return '<div class="ficha"><h3>' + f.titulo + '</h3><dl>' + filas + '</dl></div>';
  }
  function pintarFichas(clave){
    var P = TIENDA.productos, el = $('fichas');
    var lista = clave === 'dos' ? [P.hija.ficha, P.hijo.ficha] : [P[clave].ficha];
    el.className = 'fichas' + (lista.length > 1 ? ' doble' : '');
    el.innerHTML = lista.map(ficha).join('');
  }

  /* ---------- fotos ---------- */
  function verFoto(f){
    $('fotoImg').src = f.src; $('fotoImg').alt = f.alt || '';
  }
  function pintarFotos(p){
    var img = $('fotoImg'), hueco = $('fotoHueco'), minis = $('miniaturas');
    if(!p.fotos.length){ img.hidden = true; hueco.hidden = false; minis.hidden = true; return; }
    img.hidden = false; hueco.hidden = true;
    verFoto(p.fotos[0]);
    if(p.fotos.length < 2){ minis.hidden = true; minis.innerHTML = ''; return; }
    minis.hidden = false;
    minis.innerHTML = p.fotos.map(function(f, i){
      return '<button type="button" class="mini" data-i="' + i + '" aria-pressed="' + (i === 0) + '" aria-label="Ver foto ' + (i + 1) + '"><img src="' + f.mini + '" alt="" loading="lazy"></button>';
    }).join('');
  }
  $('miniaturas').addEventListener('click', function(ev){
    var b = ev.target.closest('button[data-i]');
    if(!b) return;
    verFoto(TIENDA.productos[actual].fotos[+b.dataset.i]);
    this.querySelectorAll('button').forEach(function(x){ x.setAttribute('aria-pressed', String(x === b)); });
  });

  /* ---------- cambiar de producto ---------- */
  var actual = 'hija';
  function aplicar(clave){
    var P = TIENDA.productos, p = P[clave];
    var tarjeta = (p.tarjeta ? p : P.hija).tarjeta;
    actual = clave;

    $('titulo').innerHTML = p.titulo;
    $('sub').textContent = p.sub;
    var ahora = rebajado(p.precio), suelto = P.hija.precio + P.hijo.precio;
    var pack = clave === 'dos' && p.precio > 0 && suelto > p.precio;
    var antes = enRebaja ? p.precio : (pack ? suelto : 0);
    $('precio').textContent = euros(ahora);
    $('antes').hidden = !antes;
    $('antesNum').textContent = antes ? euros(antes) : '';
    $('antesTxt').textContent = enRebaja ? '' : 'por separado';
    $('ahorro').hidden = !(enRebaja || pack);
    $('ahorro').textContent = enRebaja
      ? 'Black Friday: −' + R.pct + ' % hasta el ' + R.hasta.slice(8) + '/' + R.hasta.slice(5, 7)
      : 'Ahorras ' + euros(suelto - p.precio) + ' frente a comprarlos por separado';

    pintarFotos(p);
    pintarStock(p);

    document.querySelectorAll('[data-pago]').forEach(function(a){
      a.href = p.disponible ? p.pago : '#';
      a.classList.toggle('agotado', !p.disponible);
    });
    $('ctaTxt').textContent = p.disponible ? p.cta : 'Agotado por ahora';
    $('ctaFinal').textContent = p.disponible ? 'Lo quiero · ' + euros(ahora) : 'Agotado por ahora';
    $('barraNombre').textContent = p.nombre;
    $('barraPrecio').textContent = euros(ahora) + ' · Envío gratis';
    $('incJoya').textContent = p.joya;
    $('incJoyaTxt').textContent = p.joyaTxt;
    $('callada').textContent = p.callada;
    $('tParaQuien').textContent = tarjeta.para;
    $('tLineas').innerHTML = tarjeta.lineas.map(function(l){ return '<p>' + l + '</p>'; }).join('');
    $('escenaPie').textContent = p.pie || 'Así es la tarjeta que va dentro.';
    pintarFichas(clave);
  }

  function cambiar(clave){
    if(clave === actual) return;
    if(reduce){ aplicar(clave); return; }
    document.body.classList.add('cambiando');
    setTimeout(function(){
      aplicar(clave);
      requestAnimationFrame(function(){ document.body.classList.remove('cambiando'); });
    }, 160);
    try { history.replaceState(null, '', '?para=' + clave); } catch(e){}
  }

  document.querySelectorAll('input[name="para"]').forEach(function(r){
    r.addEventListener('change', function(){ cambiar(r.value); });
  });

  /* ---------- botones de compra: van directos al pago de Shopify ---------- */
  var avisoT;
  document.querySelectorAll('[data-pago]').forEach(function(a){
    a.addEventListener('click', function(ev){
      var p = TIENDA.productos[actual];
      if(p.disponible) return;
      ev.preventDefault();
      var t = $('avisoPago');
      t.textContent = p.nombre + ' está agotado ahora mismo. Escríbenos por WhatsApp al 623 75 43 61 y te avisamos cuando vuelva.';
      t.classList.add('ver');
      clearTimeout(avisoT);
      avisoT = setTimeout(function(){ t.classList.remove('ver'); }, 4200);
    });
  });

  /* ---------- arranque ---------- */
  var inicial = new URLSearchParams(location.search).get('para');
  if(!Object.prototype.hasOwnProperty.call(TIENDA.productos, inicial)) inicial = 'hija';
  $('o-' + inicial).checked = true;
  aplicar(inicial);
  pintarFechas();

  /* aparición: lo de arriba al cargar, el resto al entrar en pantalla */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      e.target.classList.add('in');
      io.unobserve(e.target);
    });
  }, {threshold: .12, rootMargin: '0px 0px -6% 0px'});
  document.querySelectorAll('.rv').forEach(function(el){ if(el.id !== 'foto') io.observe(el); });

  /* the photo starts fully clipped, so it never counts as visible: reveal it on load (it is always at the top) */
  requestAnimationFrame(function(){
    $('foto').classList.add('in');
    setTimeout(function(){ $('foto').classList.add('lista'); }, 600);
  });

  /* la tarjeta sale de la caja una vez */
  var ioCaja = new IntersectionObserver(function(es){
    if(es[0].isIntersecting){ $('escena').classList.add('abierta'); ioCaja.disconnect(); }
  }, {threshold: .45});
  ioCaja.observe($('escena'));

  /* barra fija: aparece al pasar el botón principal y se esconde en el cierre */
  var barra = $('barra'), ctaVisible = true, finalVisible = false;
  function barraEstado(){
    var ver = !ctaVisible && !finalVisible;
    barra.classList.toggle('ver', ver);
    barra.setAttribute('aria-hidden', ver ? 'false' : 'true');
    barra.querySelector('a').tabIndex = ver ? 0 : -1;
  }
  new IntersectionObserver(function(es){ ctaVisible = es[0].isIntersecting || es[0].boundingClientRect.top > 0; barraEstado(); }).observe($('cta'));
  new IntersectionObserver(function(es){ finalVisible = es[0].isIntersecting; barraEstado(); }).observe(document.querySelector('.final'));
})();